import axios from '@/plugins/axios';

const QUESTION_ANSWER = '/question-answer';
const QUESTION = '/question';
const ANSWER = '/answer';

export async function getListQuestionAndAnswers(id) {
  try {
    const { data } = await axios.get(`${QUESTION_ANSWER}/${id}`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function postQuestion(payload) {
  try {
    const { data } = await axios.post(`${QUESTION}`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function postAnswer(payload) {
  try {
    const { data } = await axios.post(`${ANSWER}`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function deleteQuestion(id) {
  try {
    const { data } = await axios.delete(`${QUESTION}/${id}`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function deleteAnswer(id) {
  try {
    const { data } = await axios.delete(`${ANSWER}/${id}`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function checkValidate(payload) {
  try {
    const { data } = await axios.post(`${QUESTION}/validate-form`, payload);
    return data;
  } catch (error) {
    return { error };
  }
}

export async function checkValidateAnswer(payload) {
  try {
    const { data } = await axios.post(`${ANSWER}/validate-form`, payload);
    return data;
  } catch (error) {
    return { error };
  }
}
